import Particles from "react-particles-js";
import "./App.css";
import { useEffect, useRef, useState } from "react";
import MainTab from "./MainTab";

const particlesParams = {
  particles: {
    number: {
      value: 50,
    },
    size: {
      value: 3,
    },
  },
  interactivity: {
    events: {
      onhover: {
        enable: true,
        mode: "repulse",
      },
    },
  },
};

const App = () => {
  const containerRef = useRef(null);
  const [currentTab, setCurrentTab] = useState("Main");

  useEffect(() => {
    if (containerRef?.current) {
      setTimeout(() => {
        containerRef.current.className = "App";
      }, 0);
    }
  }, []);

  return (
    <div
      className="beforeApp"
      style={{
        position: "relative",
        overflow: "auto",
      }}
      ref={containerRef}
    >
      <div style={{ position: "absolute" }}>
        <Particles height="100vh" width="100vw" params={particlesParams} />
      </div>
      <div>
        <MainTab currentTab={currentTab} setCurrentTab={setCurrentTab} />
      </div>
    </div>
  );
};

export default App;
